import { useState } from "react";
import { LitigationFunnelMatter } from "../../../api/models/LitigationFunnelMatter";
import { LitigationArea } from "./Areas";
import { Area } from "./Area";
import { AppButton, FilterBar, PageHeader, REPORT_PAGE_SX } from "../../../components/ui";
import { Box } from "@mui/material";
import { LitigationReportRequest } from "../../../api/models/LitigationReportRequest";
import { MatterData } from "../../../api/models/MatterData";
import FilterableSelect from "../../../components/basic/FilterableSelect";
import {
  ApSelect,
  RaaSelect,
  SaSelect,
  SmaSelect,
} from "../../../components/shared/ClioSelects";

type Props = {
    title: string;
    subtitle?: string;
    areas: LitigationArea[];
    matters: LitigationFunnelMatter[];
    matterOptions: MatterData[];
    loadReport: (filter: LitigationReportRequest) => void;
}

export default function StagesReport({
    title,
    subtitle,
    areas,
    matters,
    matterOptions,
    loadReport
}: Props) {
    const [reportFilter, setReportFilter] = useState<LitigationReportRequest>({})

    const handleLoadReport = () => {
        loadReport(reportFilter);
    }

    return (
        <Box sx={{ ...REPORT_PAGE_SX, gap: 2, paddingTop: 2 }}>
            <PageHeader title={title} subtitle={subtitle} />
            <FilterBar
                hideFilterButton
                hideClearButton
                leading={
                    <>
                        <FilterableSelect
                            label="Matter"
                            size="small"
                            value={reportFilter.matterId}
                            options={matterOptions.map((matter) => ({
                                value: matter.id,
                                label: matter.display_number,
                            }))}
                            onChange={(matterId) => setReportFilter((prev) => ({
                                ...prev,
                                matterId: matterId as number | undefined,
                            }))}
                            minWidth={220}
                            sx={{ bgcolor: "background.paper" }}
                        />
                        <RaaSelect
                            size="small"
                            value={reportFilter.raa}
                            includeNone
                            onChange={(raa) => setReportFilter((prev) => ({
                                ...prev,
                                raa: raa as number | undefined,
                            }))}
                            sx={{ bgcolor: "background.paper" }}
                        />
                        <SmaSelect
                            size="small"
                            value={reportFilter.sma}
                            includeNone
                            onChange={(sma) => setReportFilter((prev) => ({
                                ...prev,
                                sma: sma as number | undefined,
                            }))}
                            sx={{ bgcolor: "background.paper" }}
                        />
                        <SaSelect
                            size="small"
                            value={reportFilter.sa}
                            includeNone
                            onChange={(sa) => setReportFilter((prev) => ({
                                ...prev,
                                sa: sa as number | undefined,
                            }))}
                            sx={{ bgcolor: "background.paper" }}
                        />
                        <ApSelect
                            size="small"
                            value={reportFilter.ap}
                            includeNone
                            onChange={(ap) => setReportFilter((prev) => ({
                                ...prev,
                                ap: ap as number | undefined,
                            }))}
                            sx={{ bgcolor: "background.paper" }}
                        />
                    </>
                }
                trailing={
                    <AppButton
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleLoadReport}
                    >
                        Load Report
                    </AppButton>
                }
            />
            
            <Box 
                sx={{
                    display: 'flex',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    gap: 4,
                    flexWrap: 'nowrap',
                    flex: 1,
                    padding: 1,
                    minHeight: 0,
                }}>
                {areas.map(area => (
                    <Area
                        key={area.area}
                        area={area}
                        matters={matters.filter(m => m.area === area.area)}
                    />
                ))}
            </Box>
        </Box>
    );
}
